(function () {
	'use strict';

	angular.module('app.core')
		.directive('shortagePoActionsChart', shortagePoActionsChart);

	function shortagePoActionsChart($window, $filter, $rootScope, $timeout,
			$state, integerFormatService, currencyFormatService, $translate) {

		return {
			restrict: 'A',
			scope: {},
			link: function (scope, elem, attrs) {
				var scopeAccessor = scope.$parent.$parent;

				scope.chartData = scopeAccessor.chartData;
				scope.currency = scopeAccessor.currency;
				var chart;
				var chartListener;
				var yAxisFieldLabel = '';
				var xAxisFieldLabel = '';
				var data = [];
				var numAxisTicks = 3;

				var w = angular.element($window);
				var width = Math.max(w.width(), window.innerWidth);
				scope.height = window.innerHeight;
				scope.paddingTop = 4;
				scope.paddingBottom = 0;
				// give element unique id
				elem[0].id = elem[0].id + scope.$id;
				var chartHeight = 250;
				if (scope.chartHeight) {
					chartHeight = scope.chartHeight;
				}

				var slideshow = false;
				if (jQuery(elem[0]).parents('.slideshowWidget').length) {
					slideshow = true;
					scope.paddingTop = 8;
					numAxisTicks = 5;
					scope.paddingBottom = 12;
				}
				setPadding();

				scope.$watch(getWindowDimensions2, function (newValue, oldValue) {
					scope.windowWidth2 = newValue.w;
					scope.height = newValue.h;
					var currentPaddingLeft = scope.paddingLt;

					setPadding();

					if (currentPaddingLeft !== scope.paddingLt || newValue.h !== oldValue.h || slideshow) {
						$timeout(function () {
							generateChart();
						}, 0);
					}
				}, true);

				w.bind('resize', function () {
					scope.$apply();
				});

				function getWindowDimensions2() {
					return {
						'w': Math.max(w.width(), window.innerWidth),
						'h': window.innerHeight
					};
				}

				function setPadding() {
					if (slideshow) {
						chartHeight = scope.height - 130 - 65;
						scope.paddingLt = 75;
						scope.paddingRt = 22;
					} else if (scope.windowWidth2 >= 992) {
						scope.paddingLt = 59;
						scope.paddingRt = 15;
						scope.axisLabelWidth = 50;
					} else if (scope.windowWidth2 >= 768) {
						scope.paddingLt = 48;
						scope.paddingRt = 12;
						scope.axisLabelWidth = 50;
					} else {
						scope.paddingLt = 36;
						scope.paddingRt = 12;
						scope.axisLabelWidth = 30;
					}
				}

				function getTranslations(stringsToTranslate) {
					var translations = {};
					for (var i = 0; i < stringsToTranslate.length; i++) {
						translations[stringsToTranslate[i]] = $translate.instant(stringsToTranslate[i]);
					}
					return translations;
				}

				var groups = ['poCountLateBucket4','poCountLateBucket3','poCountLateBucket2','poCountLateBucket1','poCountInsideReceivingTime'];
				scope.translatedGroups = getTranslations(groups);

				function generateChart() {
					var data = scopeAccessor.chartData ? scopeAccessor.chartData : [];
					if (!data.length) {
						return;
					}
					var currency = scopeAccessor.currency;
					var dateList = [];
					angular.forEach(data, function (dp) {
						dateList.push($filter('date')(dp.date, 'MMM dd', 'UTC'));
						dp.total = (dp.poCountInsideReceivingTime || 0)
										+ (dp.poCountLateBucket1 || 0)
										+ (dp.poCountLateBucket2 || 0)
										+ (dp.poCountLateBucket3 || 0)
										+ (dp.poCountLateBucket4 || 0);
					});
					var yAxisCategories = scopeAccessor.categories;
					var startTimestamp = (data && data.length) ? data[0].date : 0;
					var endTimestamp = (data && data.length) ? data[data.length - 1].date : 0;
					// one week
					var interval = 7 * 60 * 60 * 24 * 1000;
					
					var possiblePoints = Math.ceil((endTimestamp - startTimestamp) / interval) + 1;
					var chartWidth = jQuery('#' + elem[0].id).width() - scope.paddingLt - scope.paddingRt;
					var barWidth = chartWidth / possiblePoints;

					var max = 0;
					if (data && data.length) {
						max = data[0]['total'];
						for (var i = 0; i < data.length; i++) {
							if (data[i]['total'] > max) {
								max = data[i]['total'];
							}
						}
					}
					var yMax = Math.ceil(max * 1.05);
					var multiple = numAxisTicks - 1;
					yMax = Math.ceil(yMax / multiple) * multiple;

					var config = {};
					// tell c3 where to put the chart
					config.bindto = '#' + elem[0].id;
					config.size = {
						height: chartHeight
					};
					config.padding = {
						right: scope.paddingRt,
						left: scope.paddingLt,
						top: scope.paddingTop
					};

					config.bar = {
						width: barWidth * 0.5
					};

					config.data = {
						json: data,
						type: 'bar',
						keys: {
							value: groups
						},
						groups: [groups],
						order: null,
						names: {
							poCountInsideReceivingTime: $translate.instant('Inside Receiving Time'),
							poCountLateBucket1: $translate.instant('1-10 Days'),
							poCountLateBucket2: $translate.instant('11-20 Days'),
							poCountLateBucket3: $translate.instant('21-30 Days'),
							poCountLateBucket4: $translate.instant('31+ Days')
						},
						color: function (color, d) {
							var colorCode = color;
							if (d === 'poCountInsideReceivingTime' || d.id === 'poCountInsideReceivingTime') {
								colorCode = '#89C2F5';
							} else if (d === 'poCountLateBucket1' || d.id === 'poCountLateBucket1') {
								colorCode = '#F0D34C';
							} else if (d === 'poCountLateBucket2' || d.id === 'poCountLateBucket2') {
								colorCode = '#F19B3D';
							} else if (d === 'poCountLateBucket3' || d.id === 'poCountLateBucket3') {
								colorCode = '#E1443B';
							} else if (d === 'poCountLateBucket4' || d.id === 'poCountLateBucket4') {
								colorCode = '#C6372F';
							}
							return colorCode;
						},
						selection: {
							'enabled': true
						}
					};

					config.grid = {
						x: {
							show: false
						},
						y: {
							show: true
						}
					};

					config.legend = {
						show: true
					};

					var formatService = integerFormatService;
					config.axis = {
						rotated: false,
						x: {
							type: 'category',
							categories: dateList,
							tick: {
								count: 5,
								multiline: false,
								outer: false
							}
						},
						y: {
							tick: {
								format: function (x) {
									return formatService.get(x);
								},
								count: numAxisTicks
							},
							min: 0,
							max: yMax,
							padding: {
								bottom: 0,
								top: 0
							}
						}
					};
					chart = c3.generate(config);
				}

				scope.$watch(function () {
					return jQuery('.shortage-po-actions-chart .c3-legend-item-tile').last().attr('x1');
				});

				chartListener = scope.$on('event:shortagePoActionsCtrl:getChart', function () {
					generateChart();
				});

				scope.$on('$destroy', function () {
					if (chart) {
						chart.destroy();
					}
					if (chartListener) {
						chartListener();
					}
				});
			}
		};
	}
})();
